import { flatten, startsWith } from 'lodash'

import { FieldTypes, Variable } from './interfaces'

export const convertVariableTypeToFieldType = (validVariableTypes: (FieldTypes | undefined)[], type: string) => {
  if (validVariableTypes) {
    for (const validType of validVariableTypes) {
      if (type === validType) return validType
    }
  }
}

export const isVariable = (string?: string) => startsWith(string, '$.')

export const getAllFlattenedVariables = (variables: Variable[]): Variable[] => {
  return flatten(variables?.map(variable => flattenNestedVariable(variable)))
}

const flattenNestedVariable = (variable: Variable): Variable[] => {
  if (variable.properties) {
    return [variable]
      .concat(variable.properties)
      .concat(
        flatten(
          variable.properties
            .filter((nestedVariable: Variable) => nestedVariable.properties)
            .map((nestedVariable: Variable) => flattenNestedVariable(nestedVariable))
        )
      )
  }
  return [variable]
}
